module.exports = __webpack_public_path__ + "roboto-medium-webfont.ce993c71e74d2498b109.woff2";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/roboto-medium-webfont.woff2
// module id = ../../../../../src/assets/fonts/roboto-medium-webfont.woff2
// module chunks = styles